import React, { useEffect, useRef, useState } from "react";
import useHasScrolled from "../../hooks/useHasScrolled";
import BurgerMenu from "../BurgerMenu/BurgerMenu";
import HeaderMenu from "./HeaderMenu";
import "./assets/styles/_index.scss";
const { CTALink } = require("@starberry/gatsby-theme-utils/Modules/CTALinkModule");
const Header = () => {
  const [isVisible, setIsVisible] = useState(false);
  const bugerRef = useRef();
  // Scroll
  const scrolled = useHasScrolled();
  // Scroll
  const handleToggle = () => {
    setIsVisible(!isVisible);
    if (bugerRef && bugerRef?.current) {
      bugerRef?.current.scrollTo(0, 0);
    }
  };
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  });
  return (
    <header className={`header ${scrolled ? "header-scrolled" : ""}`}>
      <HeaderMenu handleToggle={handleToggle} isVisible={isVisible} />
      <div className={`burger-menu-wrapper ${isVisible ? "isVisible" : ""}`} ref={bugerRef}>
        <BurgerMenu />
      </div>
    </header>
  );
};

export default Header;
